import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="auto-submit-form"
export default class extends Controller {
  submit() {
    // `HTMLFormElement#submit()` bypasses the "submit" event; Turbo (and requestSubmit) do not.
    this.element.requestSubmit()
  }
}
